import { styled } from 'styled-components';
import { ReactSVG } from 'react-svg';
import { VERTICAL_SPACING, PADDING } from './ExportModal.constants';
import { VISUALISATION_FONT_SETUPS } from '../../utils/constants/visText';

export const ExportContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.sizing.regular};
`;

export const ExportSettings = styled.div`
  width: 30%;
  text-align: left;
`;

export const ExportTemplateContainer = styled.div`
  max-width: 100%;
  max-height: 60vh;
  overflow: auto;

  // hide corner-square when overflow-x and overflow-y being used simultaneously
  &::-webkit-scrollbar-corner {
    background: transparent;
  }
`;

export const Export = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) =>
    theme.colours.visualisations.base.background};
  padding: ${PADDING}px;
  gap: ${VERTICAL_SPACING}px;
  font-family: ${({ theme }) => theme.font.family};
`;

export const ExportHeader = styled.header`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: ${({ theme }) => theme.sizing.small};

  > div {
    margin: 0 ${({ theme }) => theme.sizing.small};
    display: flex;
    justify-content: space-between;
    align-items: end;
    gap: ${({ theme }) => theme.sizing.regular};
  }

  > div:last-of-type {
    justify-content: end;
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colours.visualisations.text.legend.primary};
  font-size: ${VISUALISATION_FONT_SETUPS.HEADER_TITLE.SIZE}px;
  font-weight: ${VISUALISATION_FONT_SETUPS.HEADER_TITLE.WEIGHT};
  line-height: ${VISUALISATION_FONT_SETUPS.HEADER_TITLE.LINE_HEIGHT}px;
`;

export const SecondaryTitle = styled.div`
  color: ${({ theme }) => theme.colours.visualisations.text.legend.primary};
  font-size: ${VISUALISATION_FONT_SETUPS.HEADER_SUB_TITLE.SIZE}px;
  font-weight: ${VISUALISATION_FONT_SETUPS.HEADER_SUB_TITLE.WEIGHT};
  line-height: ${VISUALISATION_FONT_SETUPS.HEADER_SUB_TITLE.LINE_HEIGHT}px;
`;

export const Info = styled.div`
  color: ${({ theme }) => theme.colours.visualisations.text.legend.primary};
  font-size: ${VISUALISATION_FONT_SETUPS.HEADER_SUB_SUB_TITLE.SIZE}px;
  font-weight: ${VISUALISATION_FONT_SETUPS.HEADER_SUB_SUB_TITLE.WEIGHT};
  line-height: ${VISUALISATION_FONT_SETUPS.HEADER_SUB_SUB_TITLE.LINE_HEIGHT}px;
  text-align: end;
`;

export const ExportLogoContainer = styled(ReactSVG)`
  svg {
    fill: ${({ theme }) => theme.colours.canvas.primary.ink} !important;
    position: relative;
    left: -3rem;
  }
`;

ExportContainer.displayName = 'ExportContainer';
ExportSettings.displayName = 'ExportSettings';
ExportTemplateContainer.displayName = 'ExportTemplateContainer';
Export.displayName = 'Export';
ExportHeader.displayName = 'ExportHeader';
Title.displayName = 'Title';
SecondaryTitle.displayName = 'SecondaryTitle';
Info.displayName = 'Info';
